var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.htmlDescription)?_c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({},on),[_vm._v("info")])]}}],null,false,1321962720)},[_c('div',{staticClass:"vjsf-tooltip",domProps:{"innerHTML":_vm._s(_vm.htmlDescription)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }